import { getPageData } from '@/services/api/cms';
import setMetaData from 'Pages/utils/page-metadata';

export async function fetchAndSetPageData(name: string) {
  const pageData = await getPageData(name);
  setMetaData(pageData);
  return pageData;
}
